export default {
  AccGroupCode: "",
  AccGroupName: "",
  ParentId: null,
  Level: "L1",
  AccCode: [],
  UserModified: localStorage.getItem("UserName"),
};
